module.exports = __webpack_public_path__ + "assets/img/banner.d5bc4333.png";